import { render, staticRenderFns } from "./fujian.vue?vue&type=template&id=63fb650f&scoped=true&"
import script from "./fujian.vue?vue&type=script&lang=js&"
export * from "./fujian.vue?vue&type=script&lang=js&"
import style0 from "./fujian.vue?vue&type=style&index=0&id=63fb650f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb650f",
  null
  
)

export default component.exports